import { SVGProps } from "react";

const SvgComponent = (props: SVGProps<SVGSVGElement>) => (
  <svg
    id="\u56FE\u5C42_1"
    xmlns="http://www.w3.org/2000/svg"
    x={0}
    y={0}
    viewBox="0 0 20 20"
    xmlSpace="preserve"
    {...props}
  >
    <style>{".st0{fill:#E25C59}"}</style>
    <path
      className="st0"
      d="M10 0C4.5 0 0 4.5 0 10s4.5 10 10 10 10-4.5 10-10S15.6 0 10 0zm0 18c-4.4 0-8-3.6-8-8s3.6-8 8-8 8 3.6 8 8-3.5 8-8 8z"
    />
    <path className="st0" d="M9 15v-2h2v2H9zM9 11V5h2v6H9z" />
  </svg>
);

export default SvgComponent;
